import * as yup from 'yup';

const SignUpSchema = yup.object().shape({
    password: yup.string()
        .min(8, 'Password must be at least 8 characters')
        .required('Required'),
    email: yup.string()
        .email('Please Enter a valid email')
        .required('Required'),
    firstName: yup.string()
        .required('Required')
        .max(30),
    lastName: yup.string()
        .required('Required')
        .max(30),
    agreeToTerms: yup.boolean()
        .oneOf([true], 'Please agree to the terms of service first')
        .required('Required')
});

export default SignUpSchema;